import React, { useState } from 'react';

import { link } from '@aline/routes';
import { Grid, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PanelHeader, Spacer } from 'src/components';
import { useVersionHistoryParams } from 'src/helpers';
import { useGetDocumentVersions } from 'src/hooks';
import { UploadVersion } from 'src/version-history/UploadVersion';
import type { MonthDay } from 'src/version-history/VersionCardList';
import { VersionCardList } from 'src/version-history/VersionCardList';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  panelContainer: {
    backgroundColor: theme.appColors.background2,
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
}));

export function VersionHistoryDrawerContent(): JSX.Element {
  const theme = useTheme();
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { documentId } = useVersionHistoryParams();
  const [monthDay, setMonthDay] = useState<MonthDay | null>(null);
  const { document } = useGetDocumentVersions(documentId, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  return (
    <>
      <PanelHeader
        height={theme.appSizes.appBarHeight}
        showBackButton={!!monthDay}
        text="Version History"
        onClickBack={() => setMonthDay(null)}
      >
        <Spacer />
        {!monthDay && (
          <UploadVersion
            afterUpload={async fileVersion =>
              navigate(link.DocumentDetailVersionDetail({ documentId, versionId: fileVersion.id }))
            }
            documentId={documentId}
          />
        )}
      </PanelHeader>
      <Grid
        container
        className={classes.panelContainer}
        sx={{ flexDirection: 'column' }}
        wrap="nowrap"
      >
        <VersionCardList
          latestVersionId={document?.latestVersion.id}
          orderedVersions={document?.orderedVersions ?? []}
          setMonthDayTuple={[monthDay, setMonthDay]}
        />
      </Grid>
    </>
  );
}
